/**
 * Source badge — CHG-0083-E.
 *
 * Maps a DonationSource enum value (served on signage feed/donor_wall
 * payloads since ITER-1433) to a short human-readable label for a chip
 * next to the donor name. Null/unknown sources return null so callers
 * can suppress the chip entirely rather than render a generic one.
 *
 * The set of known sources mirrors app.models.payment_intent.DonationSource.
 * Keep the mapping in sync when sources are added to the backend enum.
 */
const LABELS: Record<string, string> = {
  dashboard: 'Office',
  kiosk: 'Kiosk',
  widget: 'Web',
  'donate-page': 'Page',
  'qr-code': 'QR',
  portal: 'Portal',
  mobile: 'App',
  session: 'Event',
  api: 'API',
  external: 'Imported',
};

export function sourceBadgeLabel(source: string | null | undefined): string | null {
  if (!source) return null;
  return LABELS[source] ?? null;
}
